<template>
  <div class="db">
    <div class="searchtop">
      <img class="search-left" src="../assets/title-gujwx.png" alt />
      <div class="search-right">
            <div class="search-select">
    <el-select class="search" v-model="optionsvalue" >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      <el-input
        class="input"
        v-model="inputcontent"
        @keyup.enter.native="onSubmit()"
        placeholder="请输入内容"
      ></el-input>
      <img style="width: 27px;height: 27px;margin-top: 7px;margin-left: 297px;position: absolute;z-index: 1;cursor: pointer;" @click="sousuo()" src="../assets/pic-search-red.png"  />
    </div>
      </div>
    </div>
    <div class="assemble">
     <div class="assemble-a">
        <div class="assemble-a-tit">
          书目分类
        </div>
        <div class="eltree">
        <el-tree
  :data="data"
  show-checkbox
  node-key="id"
  ref="tree"
  @check="currchange"
  :default-expand-all="true"
  :default-checked-keys="fenleiid"
  :props="defaultProps">
</el-tree>
</div>
     </div>
     <div class="assemble-b">
      <div class="assemble-b-tit">
        <div class="assemble-b-tit-l">搜索结果</div>
        <div class="assemble-b-tit-r">共有<span>{{dataSize}}</span>条数据</div>
      </div>

      <div class="assemble-body">
        <router-link tag="div" :to="{path:'/view/bookdetails', query:{id:item.ID}}" class="assemble-body-item setRed" v-for="(item,index) in gatherlist">
          <img class="item-left" v-bind:src=" $store.state.baseurl+ '/res/minebook/' + item.cover2" :onerror="defaultImg" alt >
          <div class="item-right">
            <span style="margin-top: 10px;height: 73px;">{{ item.bookname }}</span>
            <span style="margin-top: 40px;height: 52px;">作者：{{ item.author }}</span>
            <span>分类：{{ item.navigation }}</span>
            <span>出版年：{{ item.publicationtime }}</span>
          </div>
        </router-link>
      </div>

<!-- 
      <router-link
      tag="div"
      :to="{path:'/view/bookdetails', query:{id:item.ID}}"
      class="assemble-b-ct setRed" v-for="(item,index) in gatherlist">

        <div class="ct-a">
          <p>{{ item.contents }}</p>
        </div>
        <div class="ct-b">
          <span class="ct-b-sp1">作者：{{item.author}}</span>  <span class="ct-b-sp2">来源：{{ item.bookname }}</span>   <span class="ct-b-sp3">出版年： {{item.publicationtime}}</span>
        </div>
      </router-link> -->

     </div>

    </div>

    <div  class="search-div" >

      <div class="page">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="dataSize"
        >
        </el-pagination>
      </div>
    
    </div>
    
  </div>
</template>

<script>


import { Loading } from 'element-ui';
import VueRouter from 'vue-router';
import $ from 'jquery';
function setTextRed(searchText) {
    if(searchText != ""){
        clearSelection();
        var regExp = new RegExp(searchText, 'g');
        $('.setRed').each(function() {
            var html = $(this).html();
            var newHtml = html.replace(regExp, '<b class="search-text-color">' + searchText + '</b>');
            $(this).html(newHtml);
        })
    }
};
function clearSelection(){
    $('.setRed').each(function() {
        $(this).find('.search-text-color').each(function() {
            $(this).replaceWith($(this).html());
        });
    })
};

export default {
    name: "app",
    data() {
        return {
            data: [{
                    id: 1,
                    label: '珍稀文献',
                    children: [{
                            id: 2,
                            label: '古代文献',
                        }, {
                            id: 3,
                            label: '明清文献',
                            children: [{
                                    id: 4,
                                    label: '明清档案',
                                }]
                        }, {
                            id: 5,
                            label: '近现代文献',
                            children: [{
                                    id: 6,
                                    label: '明国档案',
                                }, {
                                    id: 7,
                                    label: '名人末刊稿',
                                }, {
                                    id: 8,
                                    label: '满铁文献',
                                }, {
                                    id: 9,
                                    label: '中日关系档案',
                                }
                            ]
                        }, {
                            id: 10,
                            label: '地方文献',
                        },
                        {
                            id: 11,
                            label: '域外文献',
                        },
                        {
                            id: 12,
                            label: '西文文献',
                        }
                    ]
                }, {
                    id: 13,
                    label: '文史工具书',
                }, {
                    id: 14,
                    label: '文献编译',
                }, {
                    id: 15,
                    label: '线装文献',
                }, {
                    id: 16,
                    label: '学术随笔',
                }, {
                    id: 17,
                    label: '研究专著',
                }],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            options: [
                { value: "1", label: "关键词" },
                { value: "2", label: "作者" },
                { value: "3", label: "出版社" },
                { value: "4", label: "书名" },
            ],
            optionsvalue: "",
            inputcontent: "",
            defaultImg: `this.src="${require('../assets/index_book.jpg')}"`,
            dataSize: 0,
            gatherlist: [],
            fenleiid: [1,13,14,15,16,17],
            currentPage: 1,
        };
    },
    methods: {
        // 左侧标签触发
        currchange(){
          this.searchlist(this.currentPage);
        },
        // 回车键
        onSubmit(msg) {
            this.searchlist(this.currentPage);
        },
        goto(id) {
            window.location.href = 'http://zhdd.qiushifang.com/details.aspx?id=' + id;
        },
        //翻页
        handleCurrentChange(page) {
            console.log('测试', page);
            this.currentPage = page;
            this.searchlist(page);
        },
        // 点击标签搜索
        sousuo(msg) {
            console.log('测试', this.$refs.tree.getCheckedKeys(true));
            this.searchlist(1);
        },
        //更新列表
        searchlist(page) {
            // this.startLoading();
            let options = { fullscreen: true };
            let loadingInstance = Loading.service(options);
            setTimeout(() => {
                loadingInstance.close();
            }, 3000);
            Loading.service(options);
            let ddown = this.optionsvalue;  
            let ctest = this.inputcontent;
            this.gatherlist = [];
            this.fenleiid = this.$refs.tree.getCheckedKeys(true);
            console.log("dd" + ddown + ctest + this.fenleiid);
            this.$http.get(`${global.BASE_URL}/api/ancient?ddown=${ddown}&ctest=${ctest}&fenleiid=${this.fenleiid}&page=${page}`).then((res) => {
                // console.log("-------",res.data)
                const json = res.data;
                const obj = JSON.parse(json);
                this.gatherlist = obj.data;
                console.log("结果" + obj.dataSize);
                this.dataSize = obj.dataSize;
                loadingInstance.close();
                return obj.dataSize;
            });
            setTimeout(() => {
              setTextRed(this.inputcontent);
            }, 500);
           
        },
    },
    created() {
        this.$http.get(`${global.BASE_URL}/api/ancient?ddown=1&ctest=&fenleiid=1&page=1`).then((res) => {
            // console.log("-------",res.data)
            const json = res.data;
            const obj = JSON.parse(json);
            this.gatherlist = obj.data;
            console.log("结果" + obj.dataSize);
            this.dataSize = obj.dataSize;
            return obj.dataSize;
        });
    },
    components: { VueRouter }
};
</script>

<style scoped lang="scss">
.assemble-body {
    width: 930px;
    height: 100%;
    
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .assemble-body-item{
      width: 450px;
      height: 225px;
      margin-left: 10px;
      margin-top: 15px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      .item-left {
        width: 166px;
        height: 221px;
        padding: 4px;
      }
      .item-right {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        span {
          padding: 5px;
          text-align: left;
        }
      }
    }
}
.assemble {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: row;
  .assemble-a {
    width: 250px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .assemble-a-tit{
      width: 250px;
      height: 51px;
      background-color: #f3e7e8;
      color: #780b27;
      font-size: 18px;
      line-height: 51px;
    }
    .eltree {
      width: 250px;
      height: 100%;
      padding-top: 20px;
      min-height: 500px;
      background-color: #ffffff;
    }
  }
  .assemble-b {
    width: 930px;
    height: 100%;
    margin-left: 20px;
    padding-bottom: 20px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .assemble-b-tit{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      .assemble-b-tit-l{
        width:150px;
        height: 61px;
        font-size: 26px;
        color: #921535;
        line-height: 61px;
      }
      .assemble-b-tit-r{
        height: 61px;
        line-height: 61px;
        margin-left: 660px;
        span{
          color: #921535;
        }
      }
    }
    .assemble-b-ct{
      width: 910px;
      height: 100%;
      max-height: 106px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      background-color: #ffffff;
      padding: 10px;
      border-bottom: 1px dashed #eeeeee;
      .ct-a{

        span{
          width: 910px;
          height: 50px;
          font-size: 15px;
          overflow: hidden;
          text-overflow:ellipsis;
        }
     
      }
      .ct-b{
        display: flex;
        flex-direction: row;
        margin-top: 23px;
        font-size: 12px;
        .ct-b-sp1{
          width: 320px;
          text-align: left;
          color: #606266;
          margin-left: 15px;
        }
        .ct-b-sp2{
          width: 400px;
          text-align: left;
          color: #606266;
          margin-left: 15px;
        }
        .ct-b-sp3{
          width: 210px;
          text-align: left;
          color: #606266;
          margin-left: 15px;
        }
      }
    }
  }
}


element.style {
  top: 167px !important;
} 

.db {

  background-color: #f0f0f0;
}
.search-select {
  width: 615px;
  height: 100%;
  display: flex;
  justify-content: center;
  
  .input {
    border-radius: 0px;
    width: 242px;
    height: 44px;
  }
  .search {
    border-radius: 0px;
    height: 48px;
    width: 100px;
    input.el-input__inner {
    border-radius: 0px;
    height: 44px !important; 
    width: 150px !important;
    padding: 0 30px 0 15px !important;
  }
  }
}

.el-select__tags-text{
  width: 24px !important;
}


.searchtop {
  width: 1200px;
  height: 100%;
  padding-top: 20px;
  margin: auto;
  display: flex;
  flex-direction: row;
  .search-left{
    left: 0px;
    width: 272px;
    height: 61px;
  }
  .search-right{
    margin-left: 450px;
  }
}



.page {
  width: 1200px;
  margin: 0 auto;
  padding: 50px;
  text-align: right;
  .active  {
    background-color: #7b112c !important;
  }
}


</style>
